module.exports = __webpack_public_path__ + "img/page-home-container1-title.67ad4a6e.png";